module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) r.d(n, o, function (t) {
      return e[t];
    }.bind(null, o));
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 2);
}([function (e, t) {
  e.exports = require("prop-types");
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  r.r(t);

  var n = r(1),
      o = r(0),
      _l = function l() {
    return (_l = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);

      return e;
    }).apply(this, arguments);
  },
      i = function i(e, t) {
    var r = {};

    for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
    }

    return r;
  },
      a = 0,
      s = n.forwardRef(function (e, t) {
    var r = e.title,
        o = void 0 === r ? null : r,
        s = e.description,
        c = void 0 === s ? null : s,
        u = e.size,
        p = void 0 === u ? null : u,
        f = e.color,
        d = void 0 === f ? "currentColor" : f,
        y = e.horizontal,
        v = void 0 === y ? null : y,
        b = e.vertical,
        m = void 0 === b ? null : b,
        h = e.rotate,
        g = void 0 === h ? null : h,
        O = e.spin,
        w = void 0 === O ? null : O,
        j = e.style,
        z = void 0 === j ? {} : j,
        E = e.children,
        P = i(e, ["title", "description", "size", "color", "horizontal", "vertical", "rotate", "spin", "style", "children"]);
    a++;

    var S,
        x = null !== w && w,
        _ = n.Children.map(E, function (e) {
      var t = e;
      !0 !== x && (x = !0 === (null === w ? t.props.spin : w));
      var r = t.props.size;
      "number" == typeof p && "number" == typeof t.props.size && (r = t.props.size / p);
      var o = {
        size: r,
        color: null === d ? t.props.color : d,
        horizontal: null === v ? t.props.horizontal : v,
        vertical: null === m ? t.props.vertical : m,
        rotate: null === g ? t.props.rotate : g,
        spin: null === w ? t.props.spin : w,
        inStack: !0
      };
      return n.cloneElement(t, o);
    });

    null !== p && (z.width = "string" == typeof p ? p : 1.5 * p + "rem");
    var k,
        T = "stack_labelledby_" + a,
        q = "stack_describedby_" + a;
    if (o) S = c ? T + " " + q : T;else if (k = "presentation", c) throw new Error("title attribute required when description is set");
    return n.createElement("svg", _l({
      ref: t,
      viewBox: "0 0 24 24",
      style: z,
      role: k,
      "aria-labelledby": S
    }, P), o && n.createElement("title", {
      id: T
    }, o), c && n.createElement("desc", {
      id: q
    }, c), x && n.createElement("style", null, "@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }", "@keyframes spin-inverse { from { transform: rotate(0deg) } to { transform: rotate(-360deg) } }"), _);
  });

  s.displayName = "Stack", s.propTypes = {
    size: o.oneOfType([o.number, o.string]),
    color: o.string,
    horizontal: o.bool,
    vertical: o.bool,
    rotate: o.number,
    spin: o.oneOfType([o.bool, o.number]),
    children: o.oneOfType([o.arrayOf(o.node), o.node]).isRequired,
    className: o.string,
    style: o.object
  }, s.defaultProps = {
    size: null,
    color: null,
    horizontal: null,
    vertical: null,
    rotate: null,
    spin: null
  };
  var c = s;
  r.d(t, "Icon", function () {
    return d;
  }), r.d(t, "Stack", function () {
    return c;
  });

  var _u = function u() {
    return (_u = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);

      return e;
    }).apply(this, arguments);
  },
      p = function p(e, t) {
    var r = {};

    for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
    }

    return r;
  },
      f = 0,
      d = n.forwardRef(function (e, t) {
    var r = e.path,
        o = e.id,
        l = void 0 === o ? ++f : o,
        i = e.title,
        a = void 0 === i ? null : i,
        s = e.description,
        c = void 0 === s ? null : s,
        d = e.size,
        y = void 0 === d ? null : d,
        v = e.color,
        b = void 0 === v ? "currentColor" : v,
        m = e.horizontal,
        h = void 0 !== m && m,
        g = e.vertical,
        O = void 0 !== g && g,
        w = e.rotate,
        j = void 0 === w ? 0 : w,
        z = e.spin,
        E = void 0 !== z && z,
        P = e.style,
        S = void 0 === P ? {} : P,
        x = e.inStack,
        _ = void 0 !== x && x,
        k = p(e, ["path", "id", "title", "description", "size", "color", "horizontal", "vertical", "rotate", "spin", "style", "inStack"]),
        T = {},
        q = [];

    null !== y && (_ ? q.push("scale(" + y + ")") : (S.width = "string" == typeof y ? y : 1.5 * y + "rem", S.height = S.width)), h && q.push("scaleX(-1)"), O && q.push("scaleY(-1)"), 0 !== j && q.push("rotate(" + j + "deg)"), null !== b && (T.fill = b);
    var M = n.createElement("path", _u({
      d: r,
      style: T
    }, _ ? k : {})),
        C = M;
    q.length > 0 && (S.transform = q.join(" "), S.transformOrigin = "center", _ && (C = n.createElement("g", {
      style: S
    }, M, n.createElement("rect", {
      width: "24",
      height: "24",
      fill: "transparent"
    }))));
    var I,
        N = C,
        R = !0 === E || "number" != typeof E ? 2 : E,
        B = !_ && (h || O);
    if (R < 0 && (B = !B), E && (N = n.createElement("g", {
      style: {
        animation: "spin" + (B ? "-inverse" : "") + " linear " + Math.abs(R) + "s infinite",
        transformOrigin: "center"
      }
    }, C, !(h || O || 0 !== j) && n.createElement("rect", {
      width: "24",
      height: "24",
      fill: "transparent"
    }))), _) return N;
    var X,
        Y = "icon_labelledby_" + l,
        A = "icon_describedby_" + l;
    if (a) I = c ? Y + " " + A : Y;else if (X = "presentation", c) throw new Error("title attribute required when description is set");
    return n.createElement("svg", _u({
      ref: t,
      viewBox: "0 0 24 24",
      style: S,
      role: X,
      "aria-labelledby": I
    }, k), a && n.createElement("title", {
      id: Y
    }, a), c && n.createElement("desc", {
      id: A
    }, c), !_ && E && (B ? n.createElement("style", null, "@keyframes spin-inverse { from { transform: rotate(0deg) } to { transform: rotate(-360deg) } }") : n.createElement("style", null, "@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }")), N);
  });

  d.displayName = "Icon", d.propTypes = {
    path: o.string.isRequired,
    size: o.oneOfType([o.number, o.string]),
    color: o.string,
    horizontal: o.bool,
    vertical: o.bool,
    rotate: o.number,
    spin: o.oneOfType([o.bool, o.number]),
    style: o.object,
    inStack: o.bool,
    className: o.string
  }, d.defaultProps = {
    size: null,
    color: "currentColor",
    horizontal: !1,
    vertical: !1,
    rotate: 0,
    spin: !1
  };
  t.default = d;
}]);